<template>
	<div>
		<modal-dialog
			:modal-visible="formListModal.visible"
			:submit-visible="false"
			cancel-button-text="Cancel"
			v-on:closeModal="formListModal.visible = false"
			title="Choose a Form to Complete">

			<div class="mb-3">
				<h3>Create a New Form</h3>

				<form-child-template-selector
					v-on:childTemplateClick="childTemplateSelected"
					:project-id="projectId"
					:service-id="serviceId"
					:worksheet-forms-only="serviceWorksheetId ? true : false">
				</form-child-template-selector>
			</div>

			<template v-if="!serviceWorksheetId">
				<template v-if="formListModal.activeForms.length > 0 && !formListModal.loadingActiveForms">
					<h3>Sign an Active Form</h3>

					<table-list record-name="Form"
						:fields="formListModal.activeFormFields"
						:records="mutatedActiveForms"
						:has-edit="true"
						edit-button-text="Open"
						v-on:edit="openActiveForm">
					</table-list>
				</template>
				<spinner v-else-if="formListModal.loadingActiveForms" :inline="true"></spinner>
			</template>

		</modal-dialog>

		<company-form-modal 
			v-if="selectedChildTemplate"
			:visible="formModal.visible" 
			:child-template-id="selectedChildTemplate.id"
			:form-id="selectedFormId"
			:project-id="projectId"
			:service-id="serviceId"
			:customer-asset-id="customerAssetId"
			:service-worksheet-id="serviceWorksheetId"
			:is-punch-in="isPunchIn"
			:is-required="isRequired"
			v-on:closeModal="closeForm">
		</company-form-modal>
	</div>
</template>
<script type="text/javascript">
import CompanyFormModal from "./CompanyFormModal"
import FormChildTemplateSelector from "@/components/company_forms/FormChildTemplateSelector"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import Spinner from "@/components/Spinner"

import JobMixins from "@/mixins/JobMixins.js"
import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "CompanyFormModalGroup",
	components: {
		ModalDialog,
		CompanyFormModal,
		FormChildTemplateSelector,
		TableList,
		Spinner
	},
	mixins: [JobMixins,FormMixins],
	props: [],
	data() {
		return {
			projectId: null,
			serviceId: null,
			customerAssetId: null,
			serviceWorksheetId: null,
			isPunchIn: null,
			isRequired: null,
			selectedChildTemplate: null,
			selectedFormId: null,
			doChildTemplateIdList: [],
			worksheetForms: [],
			formQueueIndex: 0,
			formListModal: {
				visible: false,
				activeForms: [],
				loadingActiveForms: false,
				activeFormFields: [
					{label: "Template",key: 'templateHierarchy'},
					{label: "Created At",key: 'createdAt'}
				]
			},
			formModal: {
				visible: false,
				template: [],
			},
			routeAfter: false,
		}
	},
	computed: {
		mutatedActiveForms() {
			let vm = this

			return this.formListModal.activeForms.map(form => {
				form.templateName = ""
				form.childTemplateName = ""
				form.templateHierarchy = ""
				if ("FormChildTemplate" in form && form.FormChildTemplate) {
					form.childTemplateName = form.FormChildTemplate.description
					if ("FormTemplate" in form.FormChildTemplate && form.FormChildTemplate.FormTemplate) {

						form.templateName = form.FormChildTemplate.FormTemplate.title
						form.templateHierarchy = form.templateName+" -> "+form.childTemplateName
					}
				}

				form.createdAt = vm.formatDateTimeToLocal(form.created_at)

				return form
			})
		}
	},
	methods: {
		childTemplateSelected(childTemplate) {
			let vm = this

			this.selectedChildTemplate = childTemplate
			this.formModal.visible = true
		},
		openActiveForm(record) {
			this.selectedChildTemplate = record.FormChildTemplate
			this.selectedFormId = record.id
			this.formModal.visible = true
		},
		doForm(params) {
			let vm = this

			let paramsMap = {
				job_id: "projectId",
				service_id: "serviceId",
				service_worksheet_id: "serviceWorksheetId",
				customer_asset_id: "customerAssetId",
				isPunchIn: "isPunchIn",
				allowForcedSubmit: "isRequired"
			}

			//set any data properties that apply to form params that have come in with the event.
			/*Equivelant to:
				if ('job_id' in params)
					this.projectId = params.job_id
			*/
			Object.keys(paramsMap).forEach(key => {
				if (key in params) 
					vm[paramsMap[key]] = params[key]
				else
					vm[paramsMap[key]] = null
			})

			if (this.serviceWorksheetId && !('doChildTemplateIdList' in params && params.doChildTemplateIdList.length > 0)) {
				this.fetchWorksheetForms()
				this.formListModal.visible = true
			}
			else {
				if ("doChildTemplateIdList" in params && params.doChildTemplateIdList.length > 0) {
					this.doChildTemplateIdList = params.doChildTemplateIdList
					this.startFormQueue()
				}
				else {
					this.formListModal.visible = true
					this.fetchActiveForms()
				}
			}
		},
		startFormQueue() {
			this.formQueueIndex = 0

			this.selectedChildTemplate = {
				id: this.doChildTemplateIdList[this.formQueueIndex]
			}
			this.formModal.visible = true
		},
		nextFormInQueue() {
			this.formQueueIndex++

			this.selectedChildTemplate = {
				id: this.doChildTemplateIdList[this.formQueueIndex]
			}
			this.formModal.visible = true
		},
		closeForm() {
			this.formModal.visible = false
			this.selectedChildTemplate = null
			this.selectedFormId = null

			if (this.formQueueIndex >= this.doChildTemplateIdList.length - 1 || !this.doChildTemplateIdList) {
				this.formListModal.visible = false
				if (this.routeAfter)
					this.$router.push(this.routeAfter)
			}
			else {
				this.$nextTick(() => {
					this.nextFormInQueue()
				})
			}
		},
		fetchWorksheetForms() {
			let vm = this
			this.fetchTemplates({
				spinner: true,
				worksheetFormsOnly: true,
				include: ["FormTemplateCategory"]
			}).then(response => {
				vm.worksheetForms = response.data
			})
		},
		fetchActiveForms() {
			let vm = this

			let filters = [
				["is_deactivated",0],
				["expiry >",this.moment.utc().format("YYYY-MM-DD HH:mm:ss")],
			]

			if (this.serviceId)
				filters.push(["service_id",this.serviceId])
			if (this.projectId)
				filters.push(["job_id",this.projectId])

			filters.push(["is_deactivated", 0, "or"])
			filters.push(["expiry",null])

			if (this.serviceId)
				filters.push(["service_id",this.serviceId])
			if (this.projectId)
				filters.push(["job_id",this.projectId])

			let params = {
				filters,
				include: [
					{
						model: "FormChildTemplate",
						fields: ["slug","id","description"],
						include: [
							{
								model:"FormTemplate",
								fields:["id","slug","title"]
							}
						]
					}
				]
			}

			this.spinner(true)
			this.formListModal.loadingActiveForms = true

			this.getJSON("CompanyForm/get",params).then(response => {
				vm.spinner(false)
				vm.formListModal.loadingActiveForms = false

				if (response.success)
					vm.formListModal.activeForms = response.data
			})
		}
	},
	created() {
		let vm = this

		this.$bus.$on("doCompanyForm",this.doForm)
	}
}
</script>